function updateQuantityBadge(quantity: number) {
  if (document) {
    const basketCounters = document.querySelectorAll<HTMLDivElement>(
      '.js-header-icon-link .header-icon__badge',
    );

    if (basketCounters) {
      const counters = Array.from(basketCounters);
      counters.forEach(basketLovelyCounter => {
        basketLovelyCounter.innerText = quantity.toString();
      });
    }
  }
}

export default updateQuantityBadge;
